import { RouteObject } from 'react-router'

import { ROUTES } from '@/common/constants/routes'
import { AuthenticatedLayout } from '@/common/layouts/AuthenticatedLayout'
import { PanelLayout } from '@/common/layouts/PanelLayout'
import Panel from './pages/News'

export const PanelRoutes: RouteObject[] = [
  {
    element: <AuthenticatedLayout />,
    children: [
      {
        element: <PanelLayout />,
        children: [
          {
            path: ROUTES.PANEL.NEWS,
            element: <Panel />,
          },
        ],
      },
    ],
  },
]
